<div class="div-container">
    <div class="thankyou col-md-8">
        <h2 class="mb-5">{{'SuccessRegister.thankyou' | translate}}</h2>
        <h3 class="mb-5">{{'SuccessRegister.subtitel' | translate}}</h3>
        <img class="mb-5" src="./assets/images/BeeSellerLogo.png" alt="Logo Bee Seller"/>
        <h3 class="mb-5">{{'SuccessRegister.label' | translate}}</h3>
        <h2 class="btn btn-primary mx-4 p-3" (click)="onContinue()">{{'SuccessRegister.buttonText'|translate}}</h2>
    </div>
</div>
